<template>
    <div class="form-feed">
        <div class="gcmcn-form-title">Add Channel</div>
        <div class="gcmcn-card form-feed">
            <el-form :model="form" :rules="rules" ref="form">
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-6">
                        <el-form-item class="gcmcn-form-input" prop="display_name">
                            <div class="gcmcn-form-label">Name</div>
                            <el-input
                                size="mini"
                                v-model="form.display_name"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-3">
                        <upload-file
                            style="margin-top: 20px;"
                            text="Upload thumbnails"
                            :default-image="defaultImage"
                            @image-uploaded="onCropImage"
                        ></upload-file>
                    </div>
                </div>
                <div class="gcmcn-inputs-container" style="justify-content: flex-start;">
                    <div class="flex-basis-4">
                        <el-form-item class="gcmcn-form-input" prop="default_start_time">
                            <div class="gcmcn-form-label">Default start time</div>
                            <ns-time-picker
                                v-model="form.default_start_time"
                                :disabled="cantEditChannel"
                                :display-seconds="false"
                                :display-digital-clock="true"
                            ></ns-time-picker>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-4">
                        <el-form-item class="gcmcn-form-input" prop="default_end_time">
                            <div class="gcmcn-form-label">Default end time</div>
                            <ns-time-picker
                                v-model="form.default_end_time"
                                :disabled="cantEditChannel"
                                :display-seconds="false"
                                :display-digital-clock="true"
                            ></ns-time-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="event_uid">
                            <div class="gcmcn-form-label">Event</div>
                            <el-select
                                v-model="form.event_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                :disabled="cantEditChannel"
                                placeholder="Select an event"
                                @change="eventChanged"
                            >
                                <el-option
                                    v-for="event in availableEvents"
                                    :key="event.uid"
                                    :label="event.name"
                                    :value="event.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input">
                            <div class="gcmcn-form-label">Max latency</div>
                            <el-select
                                v-model="form.max_latency_ms"
                                size="mini"
                                :disabled="cantEditChannel"
                                popper-class="gcmcn-popper"
                            >
                                <el-option
                                    v-for="lat in $store.getters.sortedLatencies"
                                    :key="lat.uid"
                                    :label="`${lat.value_ms} ms (${lat.name})`"
                                    :value="lat.value_ms"
                                >
                                </el-option>
                                <el-option label="/" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item
                    class="gcmcn-form-input radio-input"
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin"
                >
                    <div class="gcmcn-form-label">Choose redundancy</div>
                    <el-radio
                        v-model="form.redundancy_type"
                        label="1+0"
                    >
                        1+0 (MAIN only)
                    </el-radio>
                    <el-radio
                        v-model="form.redundancy_type"
                        label="1+1"
                    >
                        1+1 (MAIN+BACKUP)
                    </el-radio>
                </el-form-item>
                <div class="gcmcn-inputs-container" style="justify-content: flex-start;">
                    <div class="flex-basis-5 blankable-descr">
                        <div
                            v-if="cantEditChannel"
                        >
                            <span class="gcmcn-form-label">Is blankable ? : </span>
                            <span>{{form.is_blankable?'Yes':'No'}}</span>
                        </div>
                        <el-form-item
                            v-else
                            class="gcmcn-form-input checkbox-form-item"
                            prop="is_blankable"
                        >
                            <el-checkbox
                                class="checkbox-input"
                                v-model="form.is_blankable"
                                @change="blankableChanged"
                            >
                                <span class="gcmcn-form-label">Is blankable ?</span>
                            </el-checkbox>
                        </el-form-item>
                    </div>
                    <div
                        class="flex-basis-5"
                        v-if="(userIsAtLeastAdmin || userIsEntityAdmin) && form.is_blankable"
                    >
                        <el-form-item
                            class="gcmcn-form-input checkbox-form-item"
                            prop="enable_thumbnail_generation"
                        >
                            <el-checkbox
                                class="checkbox-input"
                                v-model="form.enable_thumbnail_generation"
                            >
                                <span class="gcmcn-form-label">Enable thumbnail generation</span>
                            </el-checkbox>
                        </el-form-item>
                    </div>
                    <div
                        v-if="form.is_blankable"
                        class="flex-basis-5"
                    >
                        <el-form-item
                            class="gcmcn-form-input"
                            prop="channel_identifier"
                        >
                            <div class="gcmcn-form-label">Channel ID</div>
                            <el-input
                                v-model="form.channel_identifier"
                                :disabled="cantEditChannel"
                                size="mini"
                                clearable
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div
                    class="flex-basis-5"
                >
                    <el-form-item
                        class="gcmcn-form-input"
                        prop="overview_page_number"
                    >
                        <div class="gcmcn-form-label">Overview page number</div>
                        <el-input-number
                            v-model="form.overview_page_number"
                            size="mini"
                            :min="0"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item
                        class="gcmcn-form-input"
                        prop="overview_page_position"
                    >
                        <div class="gcmcn-form-label">Overview page position (max : 8)</div>
                        <el-input-number
                            v-model="form.overview_page_position"
                            size="mini"
                            :min="0"
                            :max="8"
                        ></el-input-number>
                    </el-form-item>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input">
                            <div class="gcmcn-form-label" style="margin-bottom: 15px;">Description</div>
                            <el-input
                                type="textarea"
                                style="display: block;"
                                :rows="4"
                                size="mini"
                                v-model="form.description"
                                :disabled="channel !== null && channel.status === 'FINISHED'"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm">Save</el-button>
                </div>
            </el-form>
            <cropper-modal
                ref="cropper"
                @on-image-cropped="onImageCropped"
                title="Configure thumbnail"
            >
                <ul class="crop-rules">
                    <li>Image formats allowed are jpeg, jpg and png.</li>
                    <li>Best ratio 16:9</li>
                    <li>Minimal image size allowed is 400 x 225.</li>
                </ul>
            </cropper-modal>
        </div>
    </div>
</template>

<script>

import {
    CropperModal,
    UploadFile,
} from 'gcmcn-common';
import moment from 'moment';
import { mapGetters } from 'vuex';
import NsTimePicker from 'fundation-app-vuejs/src/components/partials/ns-time-picker.vue';

export default {

    components: {
        CropperModal,
        UploadFile,
        NsTimePicker,
    },

    props: {
        events: {
            type: Array,
            required: true,
        },
        channel: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
        minDurationParameter:{
            type: Number,
            required: true,
        },
    },

    data (){
        return {
            loading: false,
            form: {
                name: '',
                display_name: '',
                thumbnail: null,
                default_start_time:'',
                default_end_time:'',
                description:'',
                max_latency_ms:0,
                event_uid: '',
                channel_identifier:'',
                is_blankable: false,
                redundancy_type: '1+0',
                enable_thumbnail_generation: false,
                overview_page_number: 0,
                overview_page_position: 0
            },
            defaultImage: '',
            formInitialised: false,
        };
    },

    computed: {
        ...mapGetters([
            'entitiesByUid',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'administrableEntitiesUids'
        ]),
        rules (){
            let rules = {
                thumbnail: [{ required: true }],
                event_uid: [{ required: true }],
                display_name: [{ required: true, validator: this.authorizedCharacters }],
                default_start_time: [{  required: true, validator: this.validStartTime }],
                default_end_time: [{  required: true, validator: this.validEndTime }],
            };
            return rules;
        },
        availableEvents (){
            if(!this.channel){
                return this.events.filter(
                    (ev) => this.administrableEntitiesUids.includes(ev.scopes.entity_uid)
                );
            }
            return this.events.filter(
                (ev) => ev.scopes.entity_uid === this.channel.scopes.entity_uid
            );
        },
        cantEditChannel (){
            if(this.channel !== null && this.channel.confirmed){
                return true;
            }
            return this.channel !== null && this.channel.status === 'FINISHED';
        },
    },

    watch: {
        rules: {
            handler (){
                this.$nextTick( () => {
                    this.$refs.form.clearValidate();
                });
            },
            deep: true,
        },
    },

    mounted (){
        this.setForm();
    },
    methods: {
        eventChanged(){
            let uid = this.events.find((ev) => ev.uid === this.form.event_uid).scopes.entity_uid;
            let entity = this.entitiesByUid(uid);
            this.form.redundancy_type = entity.channel_redundancy_type;
            this.form.enable_thumbnail_generation = entity.enable_thumbnail_generation;
        },
        blankableChanged(value){
            if(value && this.form.event_uid !== ''){
                let uid = this.events.find((ev) => ev.uid === this.form.event_uid).scopes.entity_uid;
                let entity = this.entitiesByUid(uid);
                this.form.enable_thumbnail_generation = entity.enable_thumbnail_generation;
            }
        },
        validStartTime (rule, value, callback) {
            if(!this.form.default_start_time){
                return callback(new Error('Start time is required'));
            }else if(!this.form.default_start_time.match(/^([0-1][0-9]|2[0-3]|[0-9])\:([0-5][0-9]|[1-9])$/gm)){
                return callback(new Error('Start time format must match HH:mm pattern'));
            }
            callback();
        },
        validEndTime (rule, value, callback) {
            if(!this.form.default_end_time){
                return callback(new Error('End time is required'));
            }else if(!this.form.default_end_time.match(/^([0-1][0-9]|2[0-3]|[0-9])\:([0-5][0-9]|[1-9])$/gm)){
                return callback(new Error('End time format must match HH:mm pattern'));
            }

            //check if end and start time are at least 30min apart,
            let start = moment(this.form.default_start_time, 'HH:mm');
            let end = moment(this.form.default_end_time, 'HH:mm');
            let duration = moment(end.diff(start)).subtract(1, 'hours').format('HH:mm');
            let minDurationInMinutes = moment(`00:${this.minDurationParameter}`, 'HH:mm').format('HH:mm');
            if( duration < minDurationInMinutes){
                return callback(new Error(`End time must  be at least ${this.minDurationParameter} min after start time`));
            }
            callback();
        },
        authorizedCharacters(rule, value, callback) {
            if(!this.form.display_name) {
                return callback(new Error('Name is required'));
            } else if (!this.form.display_name.match(this.$store.getters.authorizedCharactersRegex)) {
                return callback(new Error('Invalid name'));
            } else {
                callback();
            }
        },
        setForm (){
            if(this.channel){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.channel)));
                // this.form.redundancy_type = this.entityRedundancy;
                this.form.default_start_time = moment.utc(this.form.default_start_time, 'HH:mm').format('HH:mm');
                this.form.default_end_time = moment.utc(this.form.default_end_time, 'HH:mm').format('HH:mm');
                this.$set(this.form, 'max_latency_ms', this.channel.max_latency_ms);
                this.$set(this.form, 'overview_page_position', this.channel.overview_page_position);
                this.$set(this.form, 'overview_page_number', this.channel.overview_page_number);
                //this.$set(this.form, 'is_blankable', this.channel.is_blankable);

            }else{
                this.$set(this, 'form', {
                    confirmed: false,
                    name: '',
                    display_name: '',
                    thumbnail: '',
                    event_uid: '',
                    default_start_time: '',
                    default_end_time: '',
                    description: '',
                    max_latency_ms: 0,
                    channel_identifier:'',
                    is_blankable: false,
                    redundancy_type: '1+0',
                    enable_thumbnail_generation: false,
                    overview_page_position: 0,
                    overview_page_number: 0,
                });
            }
            this.formInitialised = true;
        },
        onCropImage (data){
            this.$refs.cropper.open(data);
        },
        async onImageCropped (croppedImage){
            const url = croppedImage;
            this.defaultImage = url;
            const file = await this.$store.dispatch('createBlobFromUrl', {imageUrl: url});
            this.form.thumbnail = file;
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    if(!form.is_blankable){
                        form.channel_identifier = '';
                        form.enable_thumbnail_generation = false;
                    }
                    form.default_start_time = moment.utc(this.form.default_start_time, 'HH:mm:ss').format('HH:mm:ss');
                    form.default_end_time = moment.utc(this.form.default_end_time, 'HH:mm:ss').format('HH:mm:ss');

                    delete form.thumbnail;
                    let action;
                    let postData = { item: form, model: 'channels'};
                    let messageType = this.channel ? 'update' : 'create';
                    if(this.channel){
                        action = 'patchItem';
                        this.form.url = this.channel.url;
                    }else{
                        let scope = this.events.find((ev) => ev.uid === this.form.event_uid).scopes;
                        form.name = form.display_name;
                        action = 'createItem';
                        form.can_admin_users = [this.$store.getters.currentUser.uid];
                        postData.url = this.$store.state.api.meta.listModels.channels.url;
                        postData.scopes = {'X-Entity-Uid': scope.entity_uid};
                    }
                    this.$store.dispatch(action, postData).then((res) => {
                        this.$message({
                            message: `Channel ${messageType}d!`,
                            type: 'success'
                        });
                        this.show = false;
                        if(this.form.thumbnail){
                            // si ke thumbnail est un string c'est qu'il s'agit de l'url du fichier créer par le server, donc que le thumbnail n' pas été modifié
                            if(this.channel && typeof(this.form.thumbnail) === 'string') {
                                this.$emit('channel-created', res);
                                return;
                            }
                            let fd = new FormData();
                            fd.append('thumbnail', this.form.thumbnail);
                            this.$store.dispatch('patchItemFormData', {
                                item: fd,
                                url: res.url,
                                model: 'channels',
                            }).then((res) => { this.$emit('channel-created', res); }).catch((e) => {
                                console.error(e);
                                this.$message.error(`Error on channel ${messageType === 'update' ? messageType : 'creation'}.`);
                                this.loading = false;
                            });
                        }else{
                            this.$emit('channel-created', res);
                            this.loading = false;
                        }
                    }).catch((e) => {
                        console.error(e);
                        this.$message.error(`Error on channel ${messageType === 'update' ? messageType : 'creation'}.`);
                        this.loading = false;
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">
.form-feed{
    .el-switch__label:not(.is-active){
        color: #858d96;
    }
    .crop-rules{
        text-transform: initial;
        color: #bbb;

    }
    .gcmcn-danger-btn{
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .radio-input{
        margin-bottom: 0;
    }
    .blankable-descr{
        display: flex;
        align-items: center;
    }
    .checkbox-form-item{
        margin-bottom: 0;
        .checkbox-input .el-checkbox__input .el-checkbox__inner{
            border: none;
            background-color: #444;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/channels-form.vue